/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Minimal job fields for ``manual_job``-origin source rendering.
 */
export interface JobMini {
  id: string;
  title: string;
}
